import Vue from "vue"
import { App, plugin } from "@inertiajs/inertia-vue"
import { InertiaProgress } from "@inertiajs/progress"

Vue.use(plugin)

InertiaProgress.init()

const el = document.getElementById("app")

if (el) {
  const initialPage = JSON.parse(el.dataset.page)

  new Vue({
    render: (h) =>
      h(App, {
        props: {
          initialPage,
          resolveComponent: (name) =>
            import(`../pages/${name}.vue`).then((module) => module.default),
        },
      }),
  }).$mount(el)
}

